module.exports = __webpack_public_path__ + "fonts/lato-bold-greek.d9eeaf0.woff2";